import styled from 'styled-components';

export const DeactivateAccountContainer = styled.div.attrs(() => ({
  'data-testid': 'deactivate-account-container',
}))`
  text-align: center;
  padding: 3rem 0;

  ${({ theme: { media } }) =>
    media(
      '20',
      `
    text-align: left;
  `
    )};
`;

export const CancelInfoText = styled.p`
  font-family: Roboto;
  font-weight: 300;
  font-size: 20px;
`;
